import { render, staticRenderFns } from "./Points_Summary.vue?vue&type=template&id=dcc28da0&"
import script from "./Points_Summary.vue?vue&type=script&lang=js&"
export * from "./Points_Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports